export enum EGiftCardsEventName {
  GIFT_CARDS_SELECTED = 'Gift Cards Selected',
}

export enum EGroupBookingsEventName {
  GROUP_BOOKINGS_SELECTED = 'Group Bookings Selected',
}

export enum EGiftCardsEventSource {
  FOOTER = 'footer',
  NAVBAR = 'navbar',
}

export enum EGroupBookingsEventSource {
  FOOTER = 'footer',
}

export interface IGiftCardsSelectedEvent {
  source: EGiftCardsEventSource;
}

export interface IGroupBookingsSelectedEvent {
  source: EGroupBookingsEventSource;
}
